"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39890,40867],{

/***/ 290184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CashColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CashColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.435 5C2.195 5 2 5.195 2 5.436V17.609C2 17.849 2.195 18.044 2.435 18.044H21.565C21.806 18.044 22 17.849 22 17.609V5.436C22 5.195 21.806 5 21.565 5H2.435Z",
          fill: "#1CC54F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.9142 6.30505C5.9142 7.74505 4.7452 8.91305 3.3042 8.91305V14.1301C4.7452 14.1301 5.9142 15.2991 5.9142 16.7401H18.0882C18.0882 15.2991 19.2552 14.1301 20.6962 14.1301V8.91305C19.2552 8.91305 18.0882 7.74505 18.0882 6.30505H5.9142Z",
          fill: "#B9F5B4"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.95703 11.522C8.95703 13.203 10.319 14.566 12 14.566C13.681 14.566 15.044 13.203 15.044 11.522C15.044 9.841 13.681 8.479 12 8.479C10.319 8.479 8.95703 9.841 8.95703 11.522Z",
          fill: "#1CC54F"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 203281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DiscountFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DiscountFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 12C3 7.03725 7.03725 3 12 3C16.9627 3 21 7.03725 21 12C21 16.9627 16.9627 21 12 21C7.03725 21 3 16.9627 3 12ZM9 7.5C8.17125 7.5 7.5 8.17125 7.5 9C7.5 9.82875 8.17125 10.5 9 10.5C9.82875 10.5 10.5 9.82875 10.5 9C10.5 8.17125 9.82875 7.5 9 7.5ZM13.5001 15C13.5001 15.8287 14.1713 16.5 15.0001 16.5C15.8288 16.5 16.5001 15.8287 16.5001 15C16.5001 14.1712 15.8288 13.5 15.0001 13.5C14.1713 13.5 13.5001 14.1712 13.5001 15ZM9.5302 15.5302C9.23736 15.8231 8.76255 15.8231 8.4697 15.5302C8.17685 15.2374 8.17685 14.7626 8.4697 14.4697L14.4697 8.4697C14.7626 8.17685 15.2374 8.17685 15.5302 8.4697C15.8231 8.76255 15.8231 9.23735 15.5302 9.5302L9.5302 15.5302Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 971219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ GiftColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const GiftColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 26 26", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { filter: "url(#filter0_d)" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.6364 6.9847L8.7767 5.151C8.25219 4.81467 7.55366 5.06457 7.35706 5.65888L6.79962 7.34394C6.57498 8.02303 7.1381 8.70292 7.84136 8.60169L11.0885 8.13427C11.0798 8.20942 11.0754 8.28587 11.0754 8.36336C11.0754 9.44791 11.9479 10.3271 13.0242 10.3271C14.1006 10.3271 14.9731 9.44791 14.9731 8.36336C14.9731 8.2883 14.9689 8.21422 14.9608 8.14135L18.1588 8.60169C18.862 8.70292 19.4252 8.02303 19.2005 7.34394L18.6431 5.65888C18.4465 5.06457 17.7479 4.81467 17.2234 5.151L14.3933 6.96575C14.0413 6.6157 13.5578 6.39962 13.0242 6.39962C12.4811 6.39962 11.9898 6.62351 11.6364 6.9847Z",
              fill: "url(#paint0_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M6.04004 11.2901C6.04004 10.7583 6.46789 10.3271 6.99567 10.3271H19.0044C19.5322 10.3271 19.96 10.7583 19.96 11.2901V19.8687C19.96 20.4005 19.5322 20.8316 19.0044 20.8316H6.99567C6.46789 20.8316 6.04004 20.4005 6.04004 19.8687V11.2901Z",
              fill: "url(#paint1_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5 8.73245C5 8.20065 5.42785 7.76953 5.95563 7.76953H20.0444C20.5722 7.76953 21 8.20065 21 8.73245V11.3294C21 11.8613 20.5722 12.2924 20.0444 12.2924H5.95563C5.42785 12.2924 5 11.8613 5 11.3294V8.73245Z",
              fill: "url(#paint2_radial)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.71 7.76953H15.2899V12.2924H10.71V7.76953Z",
              fill: "#FED546"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.0269 12.2925H14.9729V20.8316H11.0269V12.2925Z",
              fill: "url(#paint3_linear)"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "filter",
            attr: {
              id: "filter0_d",
              x: "0",
              y: "0",
              width: "26",
              height: "25.8316",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB"
            },
            child: [
              {
                tag: "feFlood",
                attr: { floodOpacity: "0", result: "BackgroundImageFix" }
              },
              {
                tag: "feColorMatrix",
                attr: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              },
              { tag: "feOffset", attr: {} },
              { tag: "feGaussianBlur", attr: { stdDeviation: "2.5" } },
              {
                tag: "feColorMatrix",
                attr: {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 0.528167 0 0 0 0 0.379167 0 0 0 0.29 0"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow",
                  result: "shape"
                }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "13.0001",
              y1: "5",
              x2: "13.0001",
              y2: "8.30689",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FFB81E" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FED546" } }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint1_linear",
              x1: "13",
              y1: "10.3271",
              x2: "13",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          },
          {
            tag: "radialGradient",
            attr: {
              id: "paint2_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(7.61979 9.61593) rotate(61.073) scale(9.30482 8.68326)"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF5B6F" } },
              {
                tag: "stop",
                attr: { offset: "0.46875", stopColor: "#FF444F" }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint3_linear",
              x1: "12.9999",
              y1: "12.2925",
              x2: "12.9999",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              {
                tag: "stop",
                attr: { stopColor: "#FFB81E", stopOpacity: "0.66" }
              },
              {
                tag: "stop",
                attr: { offset: "0.608277", stopColor: "#FFB81E" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 86228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ShareFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShareFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
    child: [
      {
        tag: "path",
        attr: {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2",
          d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 526397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VoucherColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VoucherColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.563 20C14.785 19.1374 15.5681 18.5 16.5 18.5C17.4319 18.5 18.215 19.1374 18.437 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18.437C18.215 4.86261 17.4319 5.5 16.5 5.5C15.5681 5.5 14.785 4.86261 14.563 4L4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H14.563ZM10.3057 13.6328C10.3057 13.3757 10.2422 13.1738 10.1152 13.0273C9.98828 12.8809 9.7653 12.7425 9.44629 12.6123C9.12728 12.4821 8.83268 12.3503 8.5625 12.2168C8.29232 12.0833 8.05957 11.9287 7.86426 11.7529C7.66895 11.5771 7.51921 11.3737 7.41504 11.1426C7.31087 10.9115 7.25879 10.6315 7.25879 10.3027C7.25879 9.7526 7.44434 9.30013 7.81543 8.94531C8.18652 8.58724 8.68131 8.37891 9.2998 8.32031V7.29004H10.0762V8.33984C10.6719 8.42773 11.139 8.6735 11.4775 9.07715C11.8193 9.47754 11.9902 9.98698 11.9902 10.6055H10.3398C10.3398 10.2669 10.2747 10.0065 10.1445 9.82422C10.0143 9.64193 9.82878 9.55078 9.58789 9.55078C9.37305 9.55078 9.2054 9.61914 9.08496 9.75586C8.96777 9.88932 8.90918 10.0749 8.90918 10.3125C8.90918 10.5534 8.97754 10.7454 9.11426 10.8887C9.25098 11.0286 9.4707 11.1637 9.77344 11.2939C10.0762 11.4209 10.361 11.5544 10.6279 11.6943C10.8981 11.8311 11.1309 11.9873 11.3262 12.1631C11.5215 12.3389 11.6745 12.5439 11.7852 12.7783C11.8958 13.0127 11.9512 13.2943 11.9512 13.623C11.9512 14.1797 11.7738 14.6338 11.4189 14.9854C11.0674 15.3369 10.5872 15.542 9.97852 15.6006V16.582H9.20215V15.5957C8.49251 15.5208 7.94727 15.2783 7.56641 14.8682C7.1888 14.4548 7 13.9111 7 13.2373H8.64551C8.64551 13.6084 8.72689 13.8916 8.88965 14.0869C9.05566 14.279 9.29004 14.375 9.59277 14.375C9.81413 14.375 9.98828 14.3099 10.1152 14.1797C10.2422 14.0462 10.3057 13.8639 10.3057 13.6328ZM17.2002 16.4C17.2002 16.7314 16.9316 17 16.6002 17C16.2688 17 16.0002 16.7314 16.0002 16.4V15.52C16.0002 15.1886 16.2688 14.92 16.6002 14.92C16.9316 14.92 17.2002 15.1886 17.2002 15.52V16.4ZM17.2002 12.88C17.2002 13.2114 16.9316 13.48 16.6002 13.48C16.2688 13.48 16.0002 13.2114 16.0002 12.88L16.0002 11.12C16.0002 10.7886 16.2688 10.52 16.6002 10.52C16.9316 10.52 17.2002 10.7886 17.2002 11.12V12.88ZM17.2002 8.48C17.2002 8.81137 16.9316 9.08 16.6002 9.08C16.2688 9.08 16.0002 8.81137 16.0002 8.48V7.6C16.0002 7.26863 16.2688 7 16.6002 7C16.9316 7 17.2002 7.26863 17.2002 7.6V8.48Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "20",
              x2: "12",
              y2: "4",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 891438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SellerLine; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(853675);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29921);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => `
  display: flex;
  padding: 12px;
  align-items: center;
  background: white;
  border-bottom: ${props.border ? "1px" : "0px"} solid #e0e0e0;
`);
const Description = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;
const FlexAuto = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b)`
  flex: 0 0 auto;
`;
const SellerLine = (_a) => {
  var _b = _a, {
    seller,
    total,
    selectedCount,
    totalCount,
    border = true,
    isLogoHidden = false,
    alterName
  } = _b, props = __objRest(_b, [
    "seller",
    "total",
    "selectedCount",
    "totalCount",
    "border",
    "isLogoHidden",
    "alterName"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    border
  }), isLogoHidden ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FlexAuto, {
    marginRight: "s12"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    contain: true,
    src: (seller == null ? void 0 : seller.logo) || "",
    border: true,
    width: 38,
    height: 38,
    borderRadius: 19
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Description, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    weight: "medium"
  }, alterName ? alterName : seller == null ? void 0 : seller.displayName), totalCount && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary"
  }, selectedCount, "/", totalCount, " ", (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("s\u1EA3n ph\u1EA9m"))), total && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FlexAuto, {
    style: { fontWeight: 500 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Currency */ .F, {
    value: total,
    color: "#eb1f3a"
  })));
};




/***/ }),

/***/ 479709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ DefaultPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DiscountFilled.es.js
var DiscountFilled_es = __webpack_require__(203281);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/VoucherColored.es.js
var VoucherColored_es = __webpack_require__(526397);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DetailGifts/DetailGifts.es.js



const DetailGifts = ({
  gifts
}) => /* @__PURE__ */ react.createElement("div", null, gifts.map((gift, index) => /* @__PURE__ */ react.createElement(StyledGift, {
  key: index
}, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
  height: 32,
  width: 32,
  border: true,
  borderRadius: 2,
  contain: true,
  src: (gift == null ? void 0 : gift.image.src) || ""
})), /* @__PURE__ */ react.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ react.createElement(GiftName, null, gift.name), gift.endAt && /* @__PURE__ */ react.createElement(EndAt, null, gift.endAt))));
const StyledGift = emotion_styled_browser_esm["default"].div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
`;
const GiftName = emotion_styled_browser_esm["default"].span`
  margin-left: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
`;
const EndAt = emotion_styled_browser_esm["default"].span(({ theme }) => `
    color: ${theme == null ? void 0 : theme.colors.pending500};
    margin-left: 0.5rem;
    font-size: 0.75rem;
  `);
const Quantity = emotion_styled_browser_esm["default"].span`
  font-size: 0.75rem;
  color: #848788;
  margin-left: 0.5rem;
`;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DefaultPromotion/DefaultPromotions.es.js






const DefaultPromotions = ({
  gifts,
  discount,
  vouchers = []
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, discount > 0 && /* @__PURE__ */ react.createElement(Wrapper, null, /* @__PURE__ */ react.createElement("div", {
    style: { width: "8%" }
  }, /* @__PURE__ */ react.createElement(DiscountFilled_es/* DiscountFilled */.i, {
    size: 20,
    color: "primary500",
    style: { marginLeft: "5px" }
  })), /* @__PURE__ */ react.createElement("div", {
    style: { width: "92%" }
  }, (0,i18n_es.t)("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ react.createElement(StyledCurrency, {
    value: discount
  }))), !!gifts.length && /* @__PURE__ */ react.createElement(DetailGifts, {
    gifts
  }), vouchers.map((voucher, index) => /* @__PURE__ */ react.createElement(Wrapper, {
    key: index
  }, /* @__PURE__ */ react.createElement("div", {
    style: { width: "8%" }
  }, /* @__PURE__ */ react.createElement(VoucherColored_es/* VoucherColored */.C, {
    size: 20,
    color: "primary500",
    style: { marginLeft: "5px" }
  })), /* @__PURE__ */ react.createElement("div", {
    style: { width: "92%" }
  }, (0,i18n_es.t)("T\u1EB7ng"), " ", /* @__PURE__ */ react.createElement(Quantity, null, "x", voucher.quantity), " ", /* @__PURE__ */ react.createElement(StyledVoucherName, null, voucher.name)))));
};
const Wrapper = emotion_styled_browser_esm["default"].div`
  margin-top: 2px;
  display: flex;
`;
const StyledCurrency = (0,emotion_styled_browser_esm["default"])(Currency_es/* Currency */.F)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = emotion_styled_browser_esm["default"].span`
  color: #ed2101;
  font-weight: 500;
`;




/***/ }),

/***/ 845404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ DeliveryDatetimePicker; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(581016);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29921);




const TimeSlotSelect = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  flex-flow: wrap;
  margin: 0 -0.25rem;
  padding-bottom: 0.25rem;

  > * {
    margin: 0 0.25rem 0.5rem;
  }
`;
const TimeSlotOptionDiv = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({
  theme,
  highlighted,
  disabled
}) => `
  min-width: 5.75rem;
  padding: 0.625rem 0.375rem;
  border: 1px solid ${highlighted ? theme == null ? void 0 : theme.colors.primary500 : theme == null ? void 0 : theme.colors.disable};
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  text-align: center;
  background-color: ${disabled ? "#DCDEE9" : "none"};
`);
const TimeSlotOption = ({
  from,
  to,
  highlighted = false,
  disabled = false,
  onClick = () => {
  }
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TimeSlotOptionDiv, {
    highlighted,
    onClick,
    disabled
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    level: 1,
    color: highlighted ? "primary500" : "textPrimary"
  }, `${from} - ${to}`));
};
const StyledDatetimePicker = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .DateTimePicker */ .x)`
  margin-bottom: 0.75rem;
  width: 12rem;

  input {
    background-color: transparent;
  }
`;
const DeliveryDatetimePicker = ({
  selectedTimeSlot,
  timeSlots = [],
  hideTitle = false,
  selectedDate,
  enableDates,
  onChange = () => {
  }
}) => {
  const newSelectedTimeSlot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (selectedTimeSlot)
      return timeSlots.find((timeSlot) => timeSlot.from === selectedTimeSlot.from && timeSlot.to === selectedTimeSlot.to);
    return selectedTimeSlot;
  }, [timeSlots, selectedTimeSlot]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!!(newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.disabled) && (selectedTimeSlot == null ? void 0 : selectedTimeSlot.disabled) !== newSelectedTimeSlot.disabled) {
      onChange(selectedDate, void 0);
    }
  }, [newSelectedTimeSlot]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !hideTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 4
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Ch\u1ECDn ng\xE0y nh\u1EADn h\xE0ng")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDatetimePicker, {
    id: "selected-date-picker",
    value: selectedDate,
    onChange: (val) => {
      onChange(val || void 0, newSelectedTimeSlot);
    },
    disabledDate: (date) => !(enableDates == null ? void 0 : enableDates.some((val) => date.getDate() === val.getDate() && date.getMonth() === val.getMonth() && date.getFullYear() === val.getFullYear()))
  }), !!(timeSlots == null ? void 0 : timeSlots.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !hideTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 4
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Ch\u1ECDn khung gi\u1EDD")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TimeSlotSelect, {
    id: "selected-time-picker"
  }, timeSlots.map((timeSlot, i) => {
    const highlight = (timeSlot == null ? void 0 : timeSlot.from) === (newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.from) && (timeSlot == null ? void 0 : timeSlot.to) === (newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.to) && !(newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.disabled);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TimeSlotOption, {
      key: i,
      from: timeSlot.from,
      to: timeSlot.to,
      highlighted: highlight,
      disabled: timeSlot.disabled,
      onClick: () => {
        if (!timeSlot.disabled)
          onChange(selectedDate, highlight ? {
            from: void 0,
            to: void 0
          } : timeSlot);
      }
    });
  }))));
};




/***/ }),

/***/ 124902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(203494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29921);






const Description = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ content, maxHeight, showLessLabel, showMoreLabel, className }, ref) => {
  const contentWrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const htmlRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
  const expandContent = (showMore) => {
    var _a, _b;
    const contentElement = htmlRef.current;
    setExpanded(showMore);
    if (showMore) {
      (_a = contentWrapper.current) == null ? void 0 : _a.style.setProperty("max-height", (contentElement == null ? void 0 : contentElement.offsetHeight) + "px");
    } else {
      (_b = contentWrapper.current) == null ? void 0 : _b.style.setProperty("max-height", maxHeight + "px");
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const contentElement = htmlRef.current;
    if (contentElement) {
      const { offsetHeight } = contentElement;
      if (offsetHeight > maxHeight) {
        expandContent(false);
      }
    }
  }, [htmlRef]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ContentWrapper, {
    ref: contentWrapper,
    maxHeight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(HtmlRenderer, {
    ref: htmlRef,
    dangerouslySetInnerHTML: { __html: content }
  }))), expanded !== void 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ShowMoreButton, {
    block: true,
    size: "s",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .RightOutlined */ .g, {
      className: "suffix",
      "aria-expanded": expanded
    }),
    onClick: () => expandContent(!expanded)
  }, expanded ? showLessLabel : showMoreLabel));
});
const ContentWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  overflow: hidden;
  max-height: ${(props) => props.maxHeight}px;
  transition: max-height 0.5s ease-in-out;
`;
const HtmlRenderer = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  max-width: 100%;
  img {
    max-width: 100%;
  }
`;
const ShowMoreButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)`
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.divider};
  border-radius: 0;
  color: ${(props) => props.theme.colors.link500};
  padding: 0.625rem;
  height: unset;

  .button-text {
    font-weight: 400;
  }
  :hover {
    border-top: 1px solid ${(props) => props.theme.colors.divider};
    color: ${(props) => props.theme.colors.link600};
  }
  .suffix {
    /* transition: transform 0.5s ease-in-out; */
    &[aria-expanded='true'] {
      transform: rotate(-90deg);
    }
  }
`;
Description.displayName = "Description";
Description.defaultProps = {
  showMoreLabel: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Xem th\xEAm"),
  showLessLabel: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Thu g\u1ECDn"),
  maxHeight: 500
};




/***/ }),

/***/ 154064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ EmptyState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/EmptyState/search-no-result.es.js
var img = "data:image/png;base64,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";
  var emptyImage = img;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/EmptyState/EmptyState.es.js





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EmptyState = (_a) => {
  var _b = _a, {
    text
  } = _b, props = __objRest(_b, [
    "text"
  ]);
  return /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, __spreadProps(__spreadValues({}, props), {
    direction: "column",
    justify: "center",
    align: "center"
  }), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    height: 128,
    width: 128,
    src: emptyImage
  }), /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    color: "#848788",
    marginTop: "s24",
    paddingLeft: "s32",
    weight: "regular"
  }, text || (0,i18n_es.t)("Kh\xF4ng t\xECm th\u1EA5y d\u1EEF li\u1EC7u")));
};




/***/ }),

/***/ 14766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FacebookComment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(724656);




const FacebookComment = ({
  href,
  numPosts,
  width,
  appId,
  language,
  colorScheme,
  mobile,
  lazy
}) => {
  const { available, fb, xfbmlParse } = (0,_useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useFacebookSDK */ .c)(appId, language);
  const [xfbmlRender, setRender] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!fb || !available)
      return;
    setRender(false);
    if (ref.current) {
      ref.current.style.height = "1px";
    }
    xfbmlParse();
    fb.Event.subscribe("xfbml.render", () => {
      setRender(true);
      if (ref.current) {
        ref.current.style.height = "auto";
      }
    });
    return () => {
      fb.Event.unsubscribe("xfbml.render", () => {
        setRender(false);
      });
    };
  }, [fb, href, numPosts, available]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, available ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !xfbmlRender && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FacebookCommentSkeleton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fb-comments",
    "data-href": href,
    "data-numposts": numPosts,
    "data-width": width,
    "data-lazy": lazy,
    "data-mobile": mobile,
    "data-colorscheme": colorScheme
  }))) : null);
};
FacebookComment.displayName = "FacebookComment";
FacebookComment.defaultProps = {
  width: "100%",
  numPosts: 5,
  colorScheme: "light",
  mobile: "auto-detect",
  lazy: true
};
const FacebookCommentSkeleton = () => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "0.5rem",
    marginBottom: "s36",
    padding: ["s8", "s0"]
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: 1,
    marginBottom: "s24"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "4rem",
    width: "100%",
    marginBottom: "s16"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  overflow: hidden;
`;




/***/ }),

/***/ 724656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useFacebookSDK; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [available, setAvailable] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _a;
    if (typeof window === "undefined")
      return;
    if (typeof FB != "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=v16.0&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};




/***/ }),

/***/ 916253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ index_es_FlashSale; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../packages/types/dist/shared/index.es.js + 1 modules
var index_es = __webpack_require__(184019);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Countdown/Countdown.es.js + 1 modules
var Countdown_es = __webpack_require__(81512);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSale/mobile/FlashSale.es.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FlashSale = ({
  productsCarousel,
  endAt,
  backgroundImage,
  title
}) => {
  return /* @__PURE__ */ react.createElement(Wrapper, {
    bgImage: backgroundImage || "https://shopfront-cdn.tekoapis.com/static/washing_machine.png"
  }, /* @__PURE__ */ react.createElement(Header, null, /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, {
    title: title || ""
  }), /* @__PURE__ */ react.createElement(Countdown_es/* Countdown */.I, {
    date: endAt || new Date(),
    size: index_es/* DSSize.medium */.hT.medium
  })), /* @__PURE__ */ react.createElement(ProductCarousel_es/* ProductCarousel */.G, __spreadValues({}, productsCarousel)));
};
const Wrapper = emotion_styled_browser_esm["default"].div`
  background-image: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 8px;
  .product-card {
    background: white;
    border-radius: 8px;
  }
`;
const Header = emotion_styled_browser_esm["default"].div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  justify-content: space-between;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/helper.es.js
var helper_es = __webpack_require__(990241);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSale/desktop/FlashSale.es.js






var FlashSale_es_defProp = Object.defineProperty;
var FlashSale_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FlashSale_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FlashSale_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FlashSale_es_defNormalProp = (obj, key, value) => key in obj ? FlashSale_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FlashSale_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FlashSale_es_hasOwnProp.call(b, prop))
      FlashSale_es_defNormalProp(a, prop, b[prop]);
  if (FlashSale_es_getOwnPropSymbols)
    for (var prop of FlashSale_es_getOwnPropSymbols(b)) {
      if (FlashSale_es_propIsEnum.call(b, prop))
        FlashSale_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FlashSale_es_FlashSale = ({
  productsCarousel,
  endAt,
  backgroundImage
}) => {
  return /* @__PURE__ */ react.createElement(StyledRow, {
    bgImage: backgroundImage ? (0,helper_es/* getImageUrlFromGoogleUserContent */.Nc)(backgroundImage, {
      width: 1232
    }) : "https://shopfront-cdn.tekoapis.com/static/washing_machine.png"
  }, /* @__PURE__ */ react.createElement(StyledCol, {
    span: 2
  }, endAt && /* @__PURE__ */ react.createElement(EndAt, null, /* @__PURE__ */ react.createElement("p", {
    style: { marginBottom: "1rem" }
  }, (0,i18n_es.t)("K\u1EBFt th\xFAc sau")), " ", /* @__PURE__ */ react.createElement(Countdown_es/* Countdown */.I, {
    date: endAt
  }))), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 10
  }, /* @__PURE__ */ react.createElement(StyledProductCarousel, FlashSale_es_spreadValues({}, productsCarousel))));
};
const EndAt = emotion_styled_browser_esm["default"].div`
  position: relative;
  top: 6rem;
`;
const StyledRow = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)`
  background-image: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 1rem 0;
`;
const StyledProductCarousel = (0,emotion_styled_browser_esm["default"])(ProductCarousel_es/* ProductCarousel */.G)`
  padding: 1rem;
`;
const StyledCol = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)`
  padding-left: 0.5rem;
  text-align: center;
  color: white;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSale/index.es.js





var index_es_defProp = Object.defineProperty;
var index_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var index_es_hasOwnProp = Object.prototype.hasOwnProperty;
var index_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var index_es_defNormalProp = (obj, key, value) => key in obj ? index_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var index_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (index_es_hasOwnProp.call(b, prop))
      index_es_defNormalProp(a, prop, b[prop]);
  if (index_es_getOwnPropSymbols)
    for (var prop of index_es_getOwnPropSymbols(b)) {
      if (index_es_propIsEnum.call(b, prop))
        index_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const index_es_FlashSale = (props) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  if (isMobile)
    return /* @__PURE__ */ react.createElement(FlashSale, index_es_spreadValues({}, props));
  return /* @__PURE__ */ react.createElement(FlashSale_es_FlashSale, index_es_spreadValues({}, props));
};




/***/ }),

/***/ 151078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ GroupBuyShareButton; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29921);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86228);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72401);






const GroupBuyShareButton = ({
  title,
  text,
  url
}) => {
  const isShareAvailable = (0,_helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__/* .isBrowserShareAvailable */ .IS)() || (0,_helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__/* .isTerraShareAvailable */ .VV)();
  const onShare = () => {
    (0,_helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__/* .share */ .BN)(title, text, url);
  };
  return isShareAvailable ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
    onClick: onShare,
    prefix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .ShareFilled */ .r, {
      size: 20,
      color: "#fff"
    }),
    paddingLeft: "s16"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("K\xEAu g\u1ECDi mua chung")) : null;
};




/***/ }),

/***/ 159586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ JustForYou; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(628054);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(806748);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ProductGrid_ProductGrid_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(480219);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(842918);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ForwardOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(75403)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod) => mod.ForwardOutlined));
const JustForYou = (_a) => {
  var _b = _a, {
    header,
    products,
    productsPerRow,
    pagination,
    isMobile,
    isLoading
  } = _b, rest = __objRest(_b, [
    "header",
    "products",
    "productsPerRow",
    "pagination",
    "isMobile",
    "isLoading"
  ]);
  if (!products || !products.length)
    return null;
  const hasMore = ((pagination == null ? void 0 : pagination.totalRecords) || 0) > ((pagination == null ? void 0 : pagination.currentPage) || 1) * ((pagination == null ? void 0 : pagination.pageLimit) || 0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BlockHeader */ .t, __spreadProps(__spreadValues({}, header), {
    title: header.title || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("S\u1EA3n ph\u1EA9m d\xE0nh cho b\u1EA1n")
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ProductGrid_ProductGrid_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductGrid */ .e, {
    products,
    productsPerRow: productsPerRow || (isMobile ? 2 : 5),
    regionName: "forYouListProduct"
  })), !isMobile && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b, {
    marginTop: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .t, __spreadProps(__spreadValues({}, pagination), {
    totalRecords: pagination == null ? void 0 : pagination.totalRecords,
    currentPage: pagination == null ? void 0 : pagination.currentPage
  }))), isMobile && hasMore && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
    justify: "center",
    marginBottom: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ShowMoreButton, {
    variant: "link",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ForwardOutlined, null),
    disabled: isLoading,
    onClick: (e) => {
      var _a2;
      e == null ? void 0 : e.preventDefault();
      (_a2 = pagination == null ? void 0 : pagination.onPageChange) == null ? void 0 : _a2.call(pagination, ((pagination == null ? void 0 : pagination.currentPage) || 1) + 1);
    }
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm s\u1EA3n ph\u1EA9m"))));
};
JustForYou.displayName = "JustForYou";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const ShowMoreButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z)`
  min-width: 250px;
  padding: 0.625rem 0.5rem;
  background-color: #fff;
  text-align: center;

  :active,
  :hover,
  :focus {
    text-decoration: none;
  }

  :active {
    color: ${({ theme }) => theme.colors.link500};
  }

  > div {
    display: unset;
  }
`;




/***/ }),

/***/ 493460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ NoProductsFound; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/assets/images/no-products-found.es.js
var img = "data:image/png;base64,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";
  var noProductsFoundImage = img;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NoProductsFound/NoProductsFound.es.js





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const NoProductsFound = (_a) => {
  var _b = _a, {
    text,
    show
  } = _b, props = __objRest(_b, [
    "text",
    "show"
  ]);
  text = text || (0,i18n_es.t)("Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o");
  if (!show)
    return null;
  return /* @__PURE__ */ react.createElement(index_es/* Shape */.b, __spreadProps(__spreadValues({
    marginTop: "s40",
    marginBottom: "s40",
    style: { textAlign: "center" }
  }, props), {
    className: "att-no-products-found"
  }), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    width: 200,
    height: 200,
    contain: true,
    src: noProductsFoundImage
  }), /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
    level: 2,
    marginTop: "s24"
  }, text));
};




/***/ }),

/***/ 580280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ OrderShipments; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(853675);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(889104);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(396556);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29921);
/* harmony import */ var _Shipment_Shipment_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(471206);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OrderShipments = (_a) => {
  var _b = _a, {
    shipments
  } = _b, rest = __objRest(_b, [
    "shipments"
  ]);
  var _a2, _b2, _c;
  const [shipmentVisible, setShipmentVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const isShowTransportProviderInfo = !!(shipmentVisible == null ? void 0 : shipmentVisible.transportProviderName) || !!(shipmentVisible == null ? void 0 : shipmentVisible.transportTrackingId);
  const isShowStatusHistories = !!((_a2 = shipmentVisible == null ? void 0 : shipmentVisible.statusChangeHistories) == null ? void 0 : _a2.length);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, __spreadProps(__spreadValues({}, rest), {
    direction: "column",
    gapY: "s16"
  }), shipments.map((shipment) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Shipment_Shipment_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Shipment */ .L, {
    shipment,
    key: shipment.shipmentId,
    onshowMore: () => {
      setShipmentVisible(shipment);
    }
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Modal */ .u, {
    size: "l",
    visible: !!shipmentVisible,
    onClose: () => {
      setShipmentVisible(void 0);
    },
    cancelText: "",
    okText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("\u0110\xF3ng"),
    onOk: () => {
      setShipmentVisible(void 0);
    },
    title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Title */ .Dx, {
      weight: "medium"
    }, shipmentVisible == null ? void 0 : shipmentVisible.name, !!(shipmentVisible == null ? void 0 : shipmentVisible.shipmentId) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, ":\xA0 ", "#", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("strong", null, shipmentVisible.shipmentId))),
    showCloseIcon: false
  }, (isShowTransportProviderInfo || isShowStatusHistories) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, null, isShowTransportProviderInfo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .JX, {
    span: ((_b2 = shipmentVisible.statusChangeHistories) == null ? void 0 : _b2.length) ? 4.5 : 12,
    style: {
      paddingRight: "1rem"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    direction: "column",
    gapY: "s8"
  }, !!shipmentVisible.transportProviderName && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    color: "textSecondary",
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "regular"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Giao h\xE0ng b\u1EDFi"), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "bold"
  }, shipmentVisible.transportProviderName)), !!shipmentVisible.transportTrackingId && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    color: "textSecondary",
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "regular"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("M\xE3 v\u1EADn \u0111\u01A1n"), ": \xA0"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, __spreadValues({
    variant: "link",
    style: {
      textDecoration: "unset"
    }
  }, !!shipmentVisible.transportTrackingUrl ? { href: shipmentVisible.transportTrackingUrl } : {}), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, null, shipmentVisible.transportTrackingId))))), isShowStatusHistories && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ShipmentStatuses, {
    span: 7.5,
    style: {
      paddingLeft: "1rem"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ShipmentStatusHistories, {
    histories: shipmentVisible.statusChangeHistories
  }))), !!((_c = shipmentVisible == null ? void 0 : shipmentVisible.invoiceItems) == null ? void 0 : _c.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ProductListWrapper, {
    direction: "column",
    gapY: "s16",
    marginTop: "s16"
  }, shipmentVisible.invoiceItems.map((item) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    key: item.sku
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    justify: "space-between",
    style: { width: "100%" },
    align: "start",
    gap: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    align: "start",
    gap: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ProductImage, {
    src: item.imageUrl || "",
    width: 80,
    height: 80,
    aspectRatio: 1,
    contain: true,
    borderRadius: 4
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    direction: "column",
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "medium"
  }, item.name), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "textSecondary",
    weight: "medium"
  }, "SKU: ", item.sku), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    gap: "s4"
  }, !!item.sellerName && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "textSecondary",
    weight: "medium"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Cung c\u1EA5p b\u1EDFi"), " "), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "link"
  }, item.sellerName))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    direction: "column",
    justify: "space-between",
    padding: ["s4", "s0"],
    gapY: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .SubTitle */ .DK, {
    weight: "bold"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(StyledCurrency, {
    formattedValue: item.formattedValue,
    value: item.unitAfterTaxPrice || 0,
    hideCurrency: true
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      textAlign: "right",
      width: "100%",
      maxWidth: "100%"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "textSecondary"
  }, "x", item.quantity || 1)))), !!item.note && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ItemNote, {
    maxHeight: "4.5em",
    expanded,
    line: 3,
    onClick: () => setExpanded(!expanded)
  }, `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Ghi ch\xFA")}: ${item.note}`)))))));
};
const ShipmentStatuses = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .JX)`
  border-left: 1px solid ${({ theme }) => theme.colors.divider};
`;
const DateTime = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS)`
  line-height: 24px;
`;
const ShipmentStatusHistories = ({ histories }) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  const [showMore, setShowMore] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
  const onShowMore = () => {
    if (!showMore) {
      if (ref.current) {
        ref.current.style.maxHeight = "999px";
      }
      setShowMore(true);
    } else {
      if (ref.current) {
        ref.current.style.maxHeight = "90px";
      }
      setShowMore(false);
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(WrapperShipmentStatusHistories, {
    direction: "column",
    gapY: "s8"
  }, histories == null ? void 0 : histories.map((history, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ShipmentStatusHistoryItem, {
    key: index,
    className: "history-item",
    align: "center",
    isActive: index === 0
  }, !!(history == null ? void 0 : history.changedAt) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(DateTime, {
    color: "textSecondary",
    weight: "medium",
    marginLeft: "s8",
    style: { width: 150 }
  }, (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .formatDate */ .p)(history.changedAt, i18next__WEBPACK_IMPORTED_MODULE_1__["default"].language || "vi")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    marginBottom: "s4",
    color: "currentColor"
  }, history == null ? void 0 : history.status))))), ((histories == null ? void 0 : histories.length) || 0) > 3 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
    variant: "link",
    paddingTop: "s16",
    onClick: onShowMore
  }, !showMore ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem th\xEAm") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Thu g\u1ECDn")));
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  max-height: 90px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  margin-bottom: 0.5rem;
`;
const WrapperShipmentStatusHistories = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)`
  position: relative;

  overflow: hidden;
  ::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 2px;
    width: 1px;
    height: calc(100% - 36px);
    border-left: 1px solid ${({ theme }) => theme.colors.divider};
    transform: translateX(50%);
  }
  > div:last-child {
    margin-bottom: 0.75rem;
  }
`;
const ShipmentStatusHistoryItem = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)`
  position: relative;
  padding-left: 0.75rem;
  color: ${({ theme, isActive }) => isActive ? theme.colors.link : theme.colors.textSecondary};
  ::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ theme, isActive }) => isActive ? theme.colors.link : theme.colors.divider};
  }
`;
const ProductListWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)`
  border-top: 1px solid ${({ theme }) => theme.colors.divider};
  padding-top: 1rem;
  margin-top: 1rem;
  max-height: 340px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 0px;
  }
`;
const ProductImage = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .LazyImage */ .w)`
  border: 1px solid ${({ theme }) => theme.colors.divider};
  min-width: 80px;
`;
const StyledCurrency = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Currency */ .F)`
  font-size: unset;
`;
const ItemNote = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div(({ maxHeight, line, expanded, theme }) => {
  return `
  display: -webkit-box;
  -webkit-line-clamp: ${expanded ? "unset" : line};
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
  max-height: ${expanded ? "fit-content" : maxHeight};
  line-height: 1.5em;
  white-space: normal;
  font-style: italic;
  color: ${theme.colors.neutral};
  word-break: break-word;
  overflow-wrap: break-word;
  padding-right: 0.25em;
  width: 100%;
`;
});




/***/ }),

/***/ 645199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ PromotionItem; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(971219);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(290184);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29921);





const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ hasBorder }) => `
  display: flex;
  margin-top: 7px;
  align-items: center;
  ${hasBorder ? " border-bottom: 1px dashed #e0e0e0; padding-bottom: 16px;" : ""}
`);
const Name = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  flex: 1;
  align-item: center;
  margin-left: 2px;
`;
const Quantity = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  color: #848788;
`;
const Applied = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  font-size: 0.625rem;
  line-height: 1rem;
  color: #848788;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  text-transform: uppercase;
  padding: 3px;
  padding-bottom: 1px;
  margin-right: 5px;
`;
const PromotionItem = ({
  item = { quantity: 1, name: "", sku: "" },
  type,
  name,
  hasBorder,
  className
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    className,
    hasBorder
  }, type === "product" || type === "voucher" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .GiftColored */ .x, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CashColored */ .B, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Name, {
    lineHeight: 20
  }, type === "product" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Quantity, null, item.quantity, "x ") : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Applied, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("\u0110\xE3 \xE1p d\u1EE5ng")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, name || item.name)));
};




/***/ }),

/***/ 471206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Shipment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(853675);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(622746);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(889104);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(396556);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29921);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Shipment = (_a) => {
  var _b = _a, {
    shipment,
    onshowMore
  } = _b, rest = __objRest(_b, [
    "shipment",
    "onshowMore"
  ]);
  var _a2;
  const shipmentStatus = (_a2 = shipment.statusChangeHistories) == null ? void 0 : _a2[0];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    align: "center",
    justify: "space-between"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    weight: "bold",
    color: "textPrimary"
  }, shipment.name, !!shipment.shipmentId && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, ": \xA0", "#", shipment.shipmentId)), shipmentStatus && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShipmentStatusWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    color: "link",
    marginBottom: "s4"
  }, shipmentStatus == null ? void 0 : shipmentStatus.status), !!(shipmentStatus == null ? void 0 : shipmentStatus.changedAt) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
    color: "textSecondary",
    weight: "medium"
  }, (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p)(shipmentStatus == null ? void 0 : shipmentStatus.changedAt, i18next__WEBPACK_IMPORTED_MODULE_1__["default"].language || "vi"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
    variant: "link",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .ForwardOutlined */ .d, {
      size: 16
    }),
    onClick: onshowMore
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem chi ti\u1EBFt"))), !!shipment.codAmount && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    color: "textSecondary"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("C\u1EA7n thanh to\xE1n"), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    color: "primary600",
    weight: "bold"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: shipment.codAmount
  }))));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k)`
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.colors.divider};
  padding: 0.75rem 1rem;
  width: 100%;
`;
const ShipmentStatusWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div`
  position: relative;
  padding: 1px 1rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  &::before {
    content: '';
    position: absolute;
    top: 6px;
    left: 4px;
    width: 1px;
    height: 80%;
    border-left: 1.5px solid ${({ theme }) => theme.colors.divider};
    transform: translateX(-50%);
  }
  &::after {
    top: 4px;
    content: '';
    position: absolute;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.link};
    border: 1px solid ${({ theme }) => theme.colors.divider};
  }
`;
const StyledCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Currency */ .F)`
  font-size: unset;
`;




/***/ }),

/***/ 732324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ SmallImage; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(788925);




const SmallImage = ({
  image,
  isActive,
  extra,
  onClick,
  onMouseEnter,
  width = 50,
  height = 50,
  borderRadius = 4,
  borderColor = "transparent",
  borderWidth = 1
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    isActive: !!isActive,
    onClick,
    onMouseEnter,
    width,
    height,
    borderRadius,
    borderColor,
    borderWidth
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_1__/* .EnhancedImage */ .N, {
    src: image.src,
    alt: image.alt,
    objectFit: "contain",
    borderRadius,
    width,
    height
  }), extra && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Extra, null, extra));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isActive,
  theme,
  width,
  height,
  borderRadius,
  borderColor,
  borderWidth
}) => `
  border-radius: ${typeof borderRadius === "string" ? borderRadius : `${borderRadius}px`};
  border: ${typeof borderWidth === "string" ? borderWidth : `${borderWidth}px`} solid ${isActive ? theme == null ? void 0 : theme.colors.primary500 : borderColor};
  position: relative;
  cursor: pointer;
  width: ${typeof width === "string" ? width : `${width}px`};
  height: ${typeof height === "string" ? height : `${height}px`};
  overflow: hidden;
`);
const Extra = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;




/***/ }),

/***/ 312408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ WarningChangePaymentMethod; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47649);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const WarningChangePaymentMethod = (_a) => {
  var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
  const { showModal } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
  const showConfirmModal = () => {
    showModal == null ? void 0 : showModal({
      children: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
        level: 1,
        style: { textAlign: "center" }
      }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Khi thay \u0111\u1ED5i th\xF4ng tin \u0111\u01A1n h\xE0ng thanh to\xE1n l\u1EA1i, \u0111\u01A1n hi\u1EC7n t\u1EA1i s\u1EBD b\u1ECB h\u1EE7y. Gi\xE1 v\xE0 khuy\u1EBFn m\u1EA1i \u0111\u01A1n h\xE0ng c\xF3 th\u1EC3 b\u1ECB thay \u0111\u1ED5i. B\u1EA1n c\xF3 ch\u1EAFc ch\u1EAFn mu\u1ED1n th\u1EF1c hi\u1EC7n thao t\xE1c n\xE0y?")),
      title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        level: 3
      }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Th\xF4ng b\xE1o")),
      onOk: onClick,
      size: "s",
      okText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("X\xE1c nh\u1EADn"),
      cancelText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("H\u1EE7y"),
      centeredTitle: true,
      cancelButtonProps: {
        size: "s"
      },
      okButtonProps: {
        size: "s"
      },
      showCloseIcon: true,
      alignFooter: "center",
      fullWidthFooter: true
    });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledWarning, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CautionOutlined */ .s, {
    color: "pending600",
    size: 24
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    level: 1,
    color: "pending600",
    marginLeft: "s4"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Tr\u01B0\u1EDDng h\u1EE3p mu\u1ED1n thay \u0111\u1ED5i h\xECnh th\u1EE9c thanh to\xE1n ho\u1EB7c c\xE1c th\xF4ng tin kh\xE1c, vui l\xF2ng"), "\xA0", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
    variant: "link",
    onClick: showConfirmModal
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("B\u1EA5m v\xE0o \u0111\xE2y"))));
};
const StyledWarning = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pending100};
  line-height: 40px;
  padding: 0.5rem;
  gap: 0.25rem;
  svg {
    min-width: 24px;
  }
`;




/***/ }),

/***/ 72401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ share; },
/* harmony export */   "IS": function() { return /* binding */ isBrowserShareAvailable; },
/* harmony export */   "VV": function() { return /* binding */ isTerraShareAvailable; }
/* harmony export */ });
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(175915);


const isBrowserShareAvailable = () => {
  return typeof navigator !== "undefined" && !!navigator.share;
};
const isTerraShareAvailable = () => _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__["default"].isAvailable();
let isSharing = false;
const share = async (title, text, url) => {
  const isTerraShare = isTerraShareAvailable();
  const isBrowserShare = isBrowserShareAvailable();
  try {
    if (!isTerraShare && !isBrowserShare || isSharing) {
      return;
    }
    isSharing = true;
    if (isTerraShare) {
      await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__["default"].share({ title, text, url });
    } else {
      await navigator.share({ title, text, url });
    }
  } catch (e) {
  } finally {
    isSharing = false;
  }
};




/***/ }),

/***/ 539890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BestSellingCategories": function() { return /* reexport */ BestSellingCategories; },
  "BlockHeader": function() { return /* reexport */ BlockHeader_es/* BlockHeader */.t; },
  "CountdownTime": function() { return /* reexport */ CountdownTime_es/* CountdownTime */.v; },
  "CustomCategoryList": function() { return /* reexport */ CustomCategoryList_es/* CustomCategoryList */.H; },
  "DEFAULT_NUMBER_DISPLAY_FORMAT": function() { return /* reexport */ constants_index_es/* DEFAULT_NUMBER_DISPLAY_FORMAT */.n6; },
  "DefaultPromotion": function() { return /* reexport */ DefaultPromotion_es/* DefaultPromotion */.R; },
  "DefaultPromotions": function() { return /* reexport */ DefaultPromotions_es/* DefaultPromotions */.G; },
  "DeliveryDatetimePicker": function() { return /* reexport */ DeliveryDatetimePicker_es/* DeliveryDatetimePicker */.a; },
  "Description": function() { return /* reexport */ Description_es/* Description */.d; },
  "DeviceProvider": function() { return /* reexport */ DeviceContext_es/* DeviceProvider */.Y; },
  "DropdownTheme": function() { return /* reexport */ TopbarDropdown_es/* DropdownTheme */.I; },
  "EmptyState": function() { return /* reexport */ EmptyState_es/* EmptyState */.u; },
  "EnhancedImage": function() { return /* reexport */ EnhancedImage_es/* EnhancedImage */.N; },
  "FacebookComment": function() { return /* reexport */ FacebookComment_es/* FacebookComment */.F; },
  "FeaturedBanners": function() { return /* reexport */ FeaturedBanners; },
  "FeaturedBrands": function() { return /* reexport */ FeaturedBrands; },
  "FlashSale": function() { return /* reexport */ FlashSale_index_es/* FlashSale */.X; },
  "FlashSaleBar": function() { return /* reexport */ FlashSaleBar_index_es/* FlashSaleBar */.P; },
  "Gallery": function() { return /* reexport */ Gallery_es/* Gallery */.r; },
  "GroupBuyShareButton": function() { return /* reexport */ GroupBuyShareButton_es/* GroupBuyShareButton */.J; },
  "HorizontalSlider": function() { return /* reexport */ HorizontalSlider_es/* HorizontalSlider */.r; },
  "HotDealTab": function() { return /* reexport */ HotDeal_index_es/* HotDealTab */.j; },
  "JustForYou": function() { return /* reexport */ JustForYou_es/* JustForYou */.L; },
  "ListCategories": function() { return /* reexport */ ListCategories; },
  "LocationPicker": function() { return /* reexport */ LocationPicker; },
  "MAX_MENU_ITEMS": function() { return /* reexport */ MenuPanel_es/* MAX_MENU_ITEMS */.K; },
  "MegaMenu": function() { return /* reexport */ MegaMenu_es/* MegaMenu */.V; },
  "MenuPanel": function() { return /* reexport */ MenuPanel_es/* MenuPanel */.G; },
  "NAMESPACE": function() { return /* reexport */ i18n_es/* NAMESPACE */.A; },
  "NavBar": function() { return /* reexport */ NavBar_es/* NavBar */.l; },
  "NextImage": function() { return /* reexport */ NextImage_es/* NextImage */.o; },
  "NoProductsFound": function() { return /* reexport */ NoProductsFound_es/* NoProductsFound */.H; },
  "OrderShipments": function() { return /* reexport */ OrderShipments_es/* OrderShipments */.t; },
  "PolicyAndService": function() { return /* reexport */ PolicyAndService_es/* PolicyAndService */.q; },
  "PriceFilter": function() { return /* reexport */ PriceFilter_es/* PriceFilter */.W; },
  "ProductCard": function() { return /* reexport */ ProductCard_es/* ProductCard */.I; },
  "ProductCarousel": function() { return /* reexport */ ProductCarousel_es/* ProductCarousel */.G; },
  "ProductCarouselWithHeader": function() { return /* reexport */ ProductCarouselWithHeader_es/* ProductCarouselWithHeader */.B; },
  "ProductGrid": function() { return /* reexport */ ProductGrid_es/* ProductGrid */.e; },
  "ProductImageCarousel": function() { return /* reexport */ ProductImageCarousel_es/* ProductImageCarousel */.O; },
  "ProductList": function() { return /* reexport */ ProductList; },
  "ProductListItem": function() { return /* reexport */ ProductListItem; },
  "ProductPrice": function() { return /* reexport */ ProductPrice_es/* ProductPrice */.j; },
  "ProductVideo": function() { return /* reexport */ ProductVideo_es/* ProductVideo */.N; },
  "PromoteBlock": function() { return /* reexport */ PromoteBlock; },
  "PromotionItem": function() { return /* reexport */ PromotionItem_es/* PromotionItem */.w; },
  "PromotionOption": function() { return /* reexport */ PromotionOption_es/* PromotionOption */.M; },
  "RecentSearch": function() { return /* reexport */ RecentSearch_es/* RecentSearch */.t; },
  "RegionPicker": function() { return /* reexport */ RegionPicker_es/* RegionPicker */.H; },
  "SOURCE_VIDEO": function() { return /* reexport */ constants_index_es/* SOURCE_VIDEO */.Ok; },
  "SelectionOption": function() { return /* reexport */ SelectionOption_es/* SelectionOption */.J; },
  "SellerCard": function() { return /* reexport */ SellerCard_es/* SellerCard */.S; },
  "SellerLine": function() { return /* reexport */ SellerLine_es/* SellerLine */.d; },
  "Shipment": function() { return /* reexport */ Shipment_es/* Shipment */.L; },
  "SmallImage": function() { return /* reexport */ SmallImages_es/* SmallImage */.K; },
  "TOPBAR_HEIGHT": function() { return /* reexport */ Topbar_es/* TOPBAR_HEIGHT */.n; },
  "TekoLink": function() { return /* reexport */ TekoLink_es/* TekoLink */.A; },
  "Topbar": function() { return /* reexport */ Topbar_es/* Topbar */.Z; },
  "TopbarButton": function() { return /* reexport */ TopbarButton_es/* TopbarButton */.S; },
  "TopbarDropdown": function() { return /* reexport */ TopbarDropdown_es/* TopbarDropdown */.g; },
  "VerticalFilter": function() { return /* reexport */ VerticalFilter_es/* VerticalFilter */.p; },
  "WarningChangePaymentMethod": function() { return /* reexport */ WarningChangePaymentMethod_es/* WarningChangePaymentMethod */.y; },
  "Zalo": function() { return /* reexport */ Zalo_es/* Zalo */.R; },
  "calculateTimeDelta": function() { return /* reexport */ time_es/* calculateTimeDelta */.m; },
  "convertMegaMenu": function() { return /* reexport */ megaMenu_es/* convertMegaMenu */.R; },
  "defaultSlider": function() { return /* reexport */ constants_index_es/* defaultSlider */.bM; },
  "formatCurrency": function() { return /* reexport */ number_es/* formatCurrency */.xG; },
  "getComponentSize": function() { return /* reexport */ index_es/* getComponentSize */.Z; },
  "isBrowserShareAvailable": function() { return /* reexport */ browser_share_es/* isBrowserShareAvailable */.IS; },
  "isTerraShareAvailable": function() { return /* reexport */ browser_share_es/* isTerraShareAvailable */.VV; },
  "lang": function() { return /* reexport */ i18n_es/* lang */.K; },
  "numberFormatter": function() { return /* reexport */ number_es/* numberFormatter */.V2; },
  "numberParser": function() { return /* reexport */ number_es/* numberParser */.kX; },
  "share": function() { return /* reexport */ browser_share_es/* share */.BN; },
  "useFacebookSDK": function() { return /* reexport */ useFacebook_es/* useFacebookSDK */.c; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/index.es.js
var index_es = __webpack_require__(649771);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/constants/index.es.js
var constants_index_es = __webpack_require__(875547);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(788925);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductCard.es.js + 6 modules
var ProductCard_es = __webpack_require__(590581);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/JustForYou/JustForYou.es.js
var JustForYou_es = __webpack_require__(159586);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/PromoteBlock/PromoteBlock.es.js





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const PromoteBlock = ({
  header,
  contentItems,
  bottomImages,
  banner
}) => {
  return /* @__PURE__ */ react.createElement(Block, null, /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, __spreadValues({}, header)), /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 4
  }, /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, __spreadProps(__spreadValues({
    hover: "zoom",
    googleImageParams: { width: 400 },
    height: "100%",
    objectFit: "cover"
  }, banner), {
    alt: header.title
  }))), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 8
  }, /* @__PURE__ */ react.createElement(ContentItemsWrapper, null, contentItems.map((item, index) => /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, __spreadProps(__spreadValues({}, item.link), {
    key: index
  }), /* @__PURE__ */ react.createElement(ContentItem, {
    key: index
  }, /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
    level: 2,
    line: 1
  }, item.name), /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    marginBottom: "s24",
    line: 1
  }, item.description), /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, __spreadProps(__spreadValues({
    hover: "zoom",
    googleImageParams: {
      width: 300
    },
    height: "94px",
    objectFit: "contain"
  }, item.image), {
    alt: item.name
  })))))))), bottomImages && /* @__PURE__ */ react.createElement(Footer, null, bottomImages.map((item, index) => /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, __spreadProps(__spreadValues({
    hover: "zoom",
    key: index,
    height: "68px",
    googleImageParams: { width: 200 },
    objectFit: "contain"
  }, item), {
    alt: item.alt || ""
  })))));
};
const ContentItemsWrapper = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px;
  background-color: #e0e0e0;
`;
const ContentItem = emotion_styled_browser_esm["default"].div(({ theme }) => `
  text-align: center;
  padding: 1rem;
  background-color: ${theme == null ? void 0 : theme.colors.white};
  height: 100%;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const Block = emotion_styled_browser_esm["default"].div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
`;
const Footer = emotion_styled_browser_esm["default"].div`
  display: flex;
  justify-content: space-between;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarouselWithHeader/ProductCarouselWithHeader.es.js
var ProductCarouselWithHeader_es = __webpack_require__(309396);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Glide/Glide.es.js + 1 modules
var Glide_es = __webpack_require__(349416);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FeaturedBrands/FeaturedBrands.es.js









var FeaturedBrands_es_defProp = Object.defineProperty;
var FeaturedBrands_es_defProps = Object.defineProperties;
var FeaturedBrands_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var FeaturedBrands_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FeaturedBrands_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FeaturedBrands_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FeaturedBrands_es_defNormalProp = (obj, key, value) => key in obj ? FeaturedBrands_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FeaturedBrands_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FeaturedBrands_es_hasOwnProp.call(b, prop))
      FeaturedBrands_es_defNormalProp(a, prop, b[prop]);
  if (FeaturedBrands_es_getOwnPropSymbols)
    for (var prop of FeaturedBrands_es_getOwnPropSymbols(b)) {
      if (FeaturedBrands_es_propIsEnum.call(b, prop))
        FeaturedBrands_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FeaturedBrands_es_spreadProps = (a, b) => FeaturedBrands_es_defProps(a, FeaturedBrands_es_getOwnPropDescs(b));
const FeaturedBrands = ({
  header,
  brands,
  slider = FeaturedBrands_es_spreadProps(FeaturedBrands_es_spreadValues({}, constants_index_es/* defaultSlider */.bM), {
    perView: 4,
    showControl: true,
    gap: 20,
    autoplay: 2e3,
    dragThreshold: 1,
    swipeThreshold: 1,
    type: "carousel"
  })
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  if (!brands || !brands.length)
    return null;
  return /* @__PURE__ */ react.createElement(Wrapper, null, /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, FeaturedBrands_es_spreadProps(FeaturedBrands_es_spreadValues({}, header), {
    title: header.title || (0,i18n_es.t)("Th\u01B0\u01A1ng hi\u1EC7u n\u1ED5i b\u1EADt")
  })), isMobile && /* @__PURE__ */ react.createElement(MobileSliderWrapper, null, brands.map((brand, index) => {
    var _a;
    return /* @__PURE__ */ react.createElement(MobileSliderItem, FeaturedBrands_es_spreadValues({
      key: index
    }, (0,helper_es/* getTrackingData */.O5)({
      index,
      regionName: "topBrands",
      target: (_a = brand == null ? void 0 : brand.link) == null ? void 0 : _a.href,
      contentName: brand == null ? void 0 : brand.name,
      isTrackContent: true
    })), /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, FeaturedBrands_es_spreadValues({}, brand.link), /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, FeaturedBrands_es_spreadProps(FeaturedBrands_es_spreadValues({
      width: "auto"
    }, brand.image), {
      googleImageParams: {
        width: 400
      },
      hover: "zoom",
      borderRadius: 8,
      objectFit: "cover",
      height: 120,
      alt: header.title || (0,i18n_es.t)("Th\u01B0\u01A1ng hi\u1EC7u n\u1ED5i b\u1EADt")
    }))));
  })), !isMobile && /* @__PURE__ */ react.createElement(SliderWrapper, null, /* @__PURE__ */ react.createElement(Glide_es/* Glide */.A, FeaturedBrands_es_spreadValues({}, slider), brands.map((brand, index) => {
    var _a, _b;
    return /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, FeaturedBrands_es_spreadProps(FeaturedBrands_es_spreadValues({
      key: index
    }, brand.link), {
      href: (_a = brand.link) == null ? void 0 : _a.href
    }), /* @__PURE__ */ react.createElement(Card, FeaturedBrands_es_spreadValues({}, (0,helper_es/* getTrackingData */.O5)({
      index,
      regionName: "topBrands",
      target: (_b = brand == null ? void 0 : brand.link) == null ? void 0 : _b.href,
      contentName: brand == null ? void 0 : brand.name,
      isTrackContent: true
    })), /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, FeaturedBrands_es_spreadProps(FeaturedBrands_es_spreadValues({}, brand.image), {
      googleImageParams: {
        width: 400
      },
      hover: "zoom",
      borderRadius: 8,
      objectFit: "cover",
      height: 140,
      alt: brand.name
    })), /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
      level: 2,
      line: 1,
      marginTop: "s16"
    }, brand.name), brand.description && /* @__PURE__ */ react.createElement(Typography_index_es/* Caption */.YS, {
      level: 1,
      weight: "regular",
      line: 1
    }, brand.description)));
  }))));
};
const Wrapper = emotion_styled_browser_esm["default"].div`
  background: white;
  border-radius: 8px;
`;
const Card = emotion_styled_browser_esm["default"].div`
  text-align: center;
`;
const SliderWrapper = emotion_styled_browser_esm["default"].div`
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
`;
const MobileSliderWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  transform: translate3d(0, 0, 0);
`;
const MobileSliderItem = emotion_styled_browser_esm["default"].div`
  flex-shrink: 0;
  margin-right: 16px;
`;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FeaturedBanners/FeaturedBanners.es.js





var FeaturedBanners_es_defProp = Object.defineProperty;
var FeaturedBanners_es_defProps = Object.defineProperties;
var FeaturedBanners_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var FeaturedBanners_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FeaturedBanners_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FeaturedBanners_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FeaturedBanners_es_defNormalProp = (obj, key, value) => key in obj ? FeaturedBanners_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FeaturedBanners_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FeaturedBanners_es_hasOwnProp.call(b, prop))
      FeaturedBanners_es_defNormalProp(a, prop, b[prop]);
  if (FeaturedBanners_es_getOwnPropSymbols)
    for (var prop of FeaturedBanners_es_getOwnPropSymbols(b)) {
      if (FeaturedBanners_es_propIsEnum.call(b, prop))
        FeaturedBanners_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FeaturedBanners_es_spreadProps = (a, b) => FeaturedBanners_es_defProps(a, FeaturedBanners_es_getOwnPropDescs(b));
const FeaturedBanners = ({
  banners,
  regionName,
  prioritized
}) => {
  if (!banners || !banners.length)
    return null;
  const googleImageWidth = Math.ceil(1232 / banners.length);
  return /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    gutter: [16, 16]
  }, banners.map((banner, index) => {
    var _a;
    return /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
      span: 12 / banners.length,
      key: index
    }, /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, FeaturedBanners_es_spreadProps(FeaturedBanners_es_spreadValues({
      borderRadius: "8px"
    }, banner), {
      tracking: (0,helper_es/* getTrackingData */.O5)({
        regionName: regionName || `horizontalBanner${banners.length}`,
        index,
        target: (_a = banner == null ? void 0 : banner.link) == null ? void 0 : _a.href,
        contentName: banner == null ? void 0 : banner.name,
        isTrackContent: true
      }),
      hover: "zoom",
      googleImageParams: {
        width: googleImageWidth
      },
      fetchPriority: prioritized ? "high" : "auto",
      alt: (banner == null ? void 0 : banner.name) || ""
    })));
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ListCategories/ListCategories.es.js






var ListCategories_es_defProp = Object.defineProperty;
var ListCategories_es_defProps = Object.defineProperties;
var ListCategories_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var ListCategories_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ListCategories_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ListCategories_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ListCategories_es_defNormalProp = (obj, key, value) => key in obj ? ListCategories_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ListCategories_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ListCategories_es_hasOwnProp.call(b, prop))
      ListCategories_es_defNormalProp(a, prop, b[prop]);
  if (ListCategories_es_getOwnPropSymbols)
    for (var prop of ListCategories_es_getOwnPropSymbols(b)) {
      if (ListCategories_es_propIsEnum.call(b, prop))
        ListCategories_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ListCategories_es_spreadProps = (a, b) => ListCategories_es_defProps(a, ListCategories_es_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (ListCategories_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && ListCategories_es_getOwnPropSymbols)
    for (var prop of ListCategories_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && ListCategories_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Category = (_a) => {
  var item = __objRest(_a, []);
  return /* @__PURE__ */ react.createElement(Item, null, /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, ListCategories_es_spreadValues({}, item.link), /* @__PURE__ */ react.createElement(EnhancedImage_es/* EnhancedImage */.N, ListCategories_es_spreadProps(ListCategories_es_spreadValues({
    width: 56,
    height: 56,
    objectFit: "cover"
  }, item.image), {
    alt: item.title,
    googleImageParams: { width: 112 }
  })), /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
    marginTop: "s8",
    level: 2,
    line: 2,
    weight: "regular",
    hoverColor: "primary500"
  }, item.title)));
};
const ListCategories = ({
  header,
  categories
}) => {
  const renderCategories = (0,react.useCallback)((categories2) => {
    if (categories2.length > 10) {
      return /* @__PURE__ */ react.createElement(Glide_es/* Glide */.A, {
        perView: 10,
        perSwipe: "|",
        type: "carousel",
        autoplay: 2e3,
        dragThreshold: false,
        showControl: false
      }, categories2.map((item, index) => /* @__PURE__ */ react.createElement(Category, ListCategories_es_spreadValues({
        key: index
      }, item))));
    } else {
      return /* @__PURE__ */ react.createElement(ContentBlock, null, categories2.map((item, index) => /* @__PURE__ */ react.createElement(Category, ListCategories_es_spreadValues({
        key: index
      }, item))));
    }
  }, []);
  return /* @__PURE__ */ react.createElement(ListCategoriesWrapper, null, /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, ListCategories_es_spreadProps(ListCategories_es_spreadValues({}, header), {
    title: header.title || (0,i18n_es.t)("Danh m\u1EE5c s\u1EA3n ph\u1EA9m")
  })), renderCategories(categories));
};
const Item = emotion_styled_browser_esm["default"].div`
  text-align: center;
  flex: 1;
`;
const ListCategoriesWrapper = emotion_styled_browser_esm["default"].div`
  background: white;
  border-radius: 8px;
`;
const ContentBlock = emotion_styled_browser_esm["default"].div`
  display: flex;
  justify-content: space-between;
  padding: 8px 16px 24px 16px;
  text-align: center;
  gap: 16px;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductGrid/ProductGrid.es.js
var ProductGrid_es = __webpack_require__(480219);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(898815);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/MegaMenu/MenuPanel.es.js
var MenuPanel_es = __webpack_require__(472522);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSale/index.es.js + 2 modules
var FlashSale_index_es = __webpack_require__(916253);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/VerticalFilter/VerticalFilter.es.js + 2 modules
var VerticalFilter_es = __webpack_require__(68018);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SelectionOption/SelectionOption.es.js
var SelectionOption_es = __webpack_require__(241291);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/RegionPicker/RegionPicker.es.js + 1 modules
var RegionPicker_es = __webpack_require__(261431);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Zalo/Zalo.es.js + 2 modules
var Zalo_es = __webpack_require__(948501);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/index.es.js + 2 modules
var FlashSaleBar_index_es = __webpack_require__(488924);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SellerCard/SellerCard.es.js
var SellerCard_es = __webpack_require__(325710);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DefaultPromotion/DefaultPromotions.es.js + 1 modules
var DefaultPromotions_es = __webpack_require__(479709);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DefaultPromotion/DefaultPromotion.es.js
var DefaultPromotion_es = __webpack_require__(136581);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/PolicyAndService/PolicyAndService.es.js
var PolicyAndService_es = __webpack_require__(556973);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SmallImage/SmallImages.es.js
var SmallImages_es = __webpack_require__(732324);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Gallery/Gallery.es.js
var Gallery_es = __webpack_require__(888393);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NoProductsFound/NoProductsFound.es.js + 1 modules
var NoProductsFound_es = __webpack_require__(493460);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(139625);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(652966);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/TopbarDropdown.es.js
var TopbarDropdown_es = __webpack_require__(154686);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(54230);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/hooks/useQuantity.es.js
var useQuantity_es = __webpack_require__(194446);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductListItem/ProductListItem.es.js








var ProductListItem_es_defProp = Object.defineProperty;
var ProductListItem_es_defProps = Object.defineProperties;
var ProductListItem_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var ProductListItem_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductListItem_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductListItem_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductListItem_es_defNormalProp = (obj, key, value) => key in obj ? ProductListItem_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductListItem_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductListItem_es_hasOwnProp.call(b, prop))
      ProductListItem_es_defNormalProp(a, prop, b[prop]);
  if (ProductListItem_es_getOwnPropSymbols)
    for (var prop of ProductListItem_es_getOwnPropSymbols(b)) {
      if (ProductListItem_es_propIsEnum.call(b, prop))
        ProductListItem_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ProductListItem_es_spreadProps = (a, b) => ProductListItem_es_defProps(a, ProductListItem_es_getOwnPropDescs(b));
var ProductListItem_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (ProductListItem_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && ProductListItem_es_getOwnPropSymbols)
    for (var prop of ProductListItem_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && ProductListItem_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AddOutlined = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(28076)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod) => mod.AddOutlined));
const ProductListItem = ({
  sku,
  imageUrl,
  name,
  stockQuantity,
  price,
  addToCart,
  ctaButton,
  contactButton,
  ctaTracking,
  tracking,
  link,
  unit,
  minStock,
  maxStock,
  currentStock,
  precisionToDisplayDecimalQuantity: precision
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const lastestPrice = price ? (0,number_es/* formatCurrency */.xG)(price.latestPrice) : "";
  const {
    quantity,
    setQuantity,
    onDecrease,
    onIncrease,
    handleUpdateQuantity
  } = (0,useQuantity_es/* useQuantity */.R)({
    addToCart,
    precision,
    baseQuantity: 1
  });
  const [quantityDesktop, setQuantityDesktop] = (0,react.useState)(0);
  const formattedTotalPrice = price ? (0,number_es/* formatCurrency */.xG)(price.latestPrice * (isMobile ? quantity : quantityDesktop)) : "";
  const handleAddToCartDesktop = async () => {
    try {
      await (addToCart == null ? void 0 : addToCart.onAddToCart(quantityDesktop));
      setQuantityDesktop(0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  const productInfo = /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, ProductListItem_es_spreadValues({}, link), /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, ProductListItem_es_spreadValues({
    level: 2,
    line: 1
  }, tracking), name)), /* @__PURE__ */ react.createElement(SkuWrapper, null, /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: "textSecondary"
  }, "SKU: ", sku), /* @__PURE__ */ react.createElement(Divider, null), unit && /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: "textSecondary"
  }, "\u0110\u01A1n v\u1ECB: ", unit)), !!(currentStock || currentStock === 0) && /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    style: { display: "flex" },
    level: 1,
    color: "textSecondary"
  }, "T\u1ED3n kho hi\u1EC7n t\u1EA1i:", " ", /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    marginLeft: "s4",
    level: 1,
    color: "success600"
  }, currentStock)), !!(minStock || minStock === 0) && /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: "textSecondary"
  }, "T\u1ED3n kho nh\u1ECF nh\u1EA5t: ", minStock), !!(maxStock || maxStock === 0) && /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: "textSecondary"
  }, "T\u1ED3n kho l\u1EDBn nh\u1EA5t: ", maxStock));
  const renderQuantity = () => {
    if (isMobile)
      return /* @__PURE__ */ react.createElement(Quantity_es/* Quantity */.h, {
        block: true,
        disabled: !!contactButton,
        quantity,
        setQuantity,
        onMinus: onDecrease,
        onPlus: onIncrease,
        min: 0,
        max: Math.min(stockQuantity, 999),
        color: "primary500",
        size: "s",
        onBlur: handleUpdateQuantity,
        onKeyPress: (e) => {
          if (e.key === "Enter")
            handleUpdateQuantity();
        },
        decimalSeparator: ".",
        precision
      });
    return /* @__PURE__ */ react.createElement(Quantity_es/* Quantity */.h, {
      disabled: !!contactButton,
      quantity: quantityDesktop,
      setQuantity: setQuantityDesktop,
      onMinus: () => setQuantityDesktop((prev) => prev - 1),
      onPlus: () => setQuantityDesktop((prev) => prev + 1),
      min: 0,
      max: Math.min(stockQuantity, 999),
      size: "s",
      decimalSeparator: ".",
      precision
    });
  };
  const renderImage = (size) => {
    return /* @__PURE__ */ react.createElement(ProductImage, {
      hover: "zoom",
      objectFit: "contain",
      width: size,
      height: size,
      src: imageUrl,
      googleImageParams: {
        width: size
      }
    });
  };
  const renderButton = () => {
    if (!isMobile) {
      const _a = ctaButton || {}, restCtaButton = ProductListItem_es_objRest(_a, ["onClick"]);
      return /* @__PURE__ */ react.createElement(react.Fragment, null, !!ctaButton && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, ProductListItem_es_spreadProps(ProductListItem_es_spreadValues(ProductListItem_es_spreadValues({
        disabled: quantityDesktop === 0
      }, restCtaButton), ctaTracking), {
        onClick: handleAddToCartDesktop,
        size: "m",
        prefix: /* @__PURE__ */ react.createElement(AddOutlined, {
          style: { marginRight: 12 },
          size: 16
        }),
        block: true
      })), !!contactButton && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, ProductListItem_es_spreadProps(ProductListItem_es_spreadValues(ProductListItem_es_spreadValues({}, contactButton), ctaTracking), {
        size: "m",
        block: true
      })));
    }
    if (!addToCart)
      return null;
    const { quantityInCart } = addToCart;
    if (quantityInCart === 0) {
      if (ctaButton)
        return /* @__PURE__ */ react.createElement(Button_es/* Button */.z, ProductListItem_es_spreadProps(ProductListItem_es_spreadValues(ProductListItem_es_spreadValues({}, ctaButton), ctaTracking), {
          size: "s",
          block: true,
          padding: "s0"
        }));
      else
        return /* @__PURE__ */ react.createElement(Button_es/* Button */.z, ProductListItem_es_spreadProps(ProductListItem_es_spreadValues(ProductListItem_es_spreadValues({}, contactButton), ctaTracking), {
          size: "s",
          block: true,
          padding: "s0"
        }));
    }
    if ((quantityInCart != null ? quantityInCart : 0) > 0) {
      return renderQuantity();
    }
  };
  return isMobile ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(WrapperRowMobile, ProductListItem_es_spreadValues({}, tracking), /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, ProductListItem_es_spreadValues({}, link), renderImage(96)), /* @__PURE__ */ react.createElement(ProductInfoMobile, null, productInfo, /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
    level: 1,
    color: "#b91d2a"
  }, lastestPrice), /* @__PURE__ */ react.createElement("div", {
    style: { marginTop: 16 }
  }, renderButton())))) : /* @__PURE__ */ react.createElement(WrapperRowDesktop, ProductListItem_es_spreadValues({
    align: "middle"
  }, tracking), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    flex: "43%"
  }, /* @__PURE__ */ react.createElement(ProductInfoWrapper, null, /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, ProductListItem_es_spreadValues({}, link), renderImage(108)), /* @__PURE__ */ react.createElement(ProductInfo, null, productInfo))), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    flex: "43%"
  }, /* @__PURE__ */ react.createElement(PaymentWrapper, null, /* @__PURE__ */ react.createElement(PurchasedPrice, null, /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: "textSecondary"
  }, "Gi\xE1 b\xE1n"), /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
    level: 1,
    weight: "bold"
  }, lastestPrice)), /* @__PURE__ */ react.createElement(QuantityInfo, null, renderQuantity()), /* @__PURE__ */ react.createElement(TotalPrice, null, /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    level: 1,
    color: "textSecondary"
  }, "T\u1ED5ng ti\u1EC1n"), /* @__PURE__ */ react.createElement(Typography_index_es/* Title */.Dx, {
    level: 2,
    color: "#b91d2a"
  }, formattedTotalPrice)))), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    flex: "14%"
  }, renderButton()));
};
const WrapperRowDesktop = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)`
  padding: 20px;
  background-color: #ffffff;
`;
const WrapperRowMobile = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)`
  padding: 18px;
  border-radius: 4px;
  background-color: #ffffff;
`;
const SkuWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  align-items: center;
`;
const ProductImage = (0,emotion_styled_browser_esm["default"])(EnhancedImage_es/* EnhancedImage */.N)`
  border: 1px solid #e4e5f0;
  border-radius: 4px;
  min-width: 108px;
`;
const TotalPrice = emotion_styled_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  align-items: end;
  margin-right: 12px;
`;
const PurchasedPrice = emotion_styled_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
const ProductInfoWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
const PaymentWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 24px;
  flex: 1 0 auto;
`;
const ProductInfo = emotion_styled_browser_esm["default"].div`
  width: 100%;
`;
const QuantityInfo = emotion_styled_browser_esm["default"].div`
  display: flex;
  gap: 40px;
  align-items: center;
`;
const Divider = emotion_styled_browser_esm["default"].div`
  width: 8px;
  height: 0;
  transform: rotate(90deg);
  border: 1px solid #e4e5f0;
  margin: 0 8px;
`;
const ProductInfoMobile = emotion_styled_browser_esm["default"].div`
  margin-left: 12px;
  flex: 1;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductList/ProductList.es.js







var ProductList_es_defProp = Object.defineProperty;
var ProductList_es_defProps = Object.defineProperties;
var ProductList_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var ProductList_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductList_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductList_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductList_es_defNormalProp = (obj, key, value) => key in obj ? ProductList_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductList_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductList_es_hasOwnProp.call(b, prop))
      ProductList_es_defNormalProp(a, prop, b[prop]);
  if (ProductList_es_getOwnPropSymbols)
    for (var prop of ProductList_es_getOwnPropSymbols(b)) {
      if (ProductList_es_propIsEnum.call(b, prop))
        ProductList_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ProductList_es_spreadProps = (a, b) => ProductList_es_defProps(a, ProductList_es_getOwnPropDescs(b));
var ProductList_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (ProductList_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && ProductList_es_getOwnPropSymbols)
    for (var prop of ProductList_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && ProductList_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductList = ({
  products,
  regionName,
  contactLink,
  className,
  hideCtaButton,
  itemsPerPage
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const ItemWrapper = isMobile ? ItemWrapperMobile : ItemWrapperDesktop;
  const router = (0,next_router.useRouter)();
  const page = router.query.page ? Number(router.query.page) : 1;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ProductList_es_Wrapper, {
    className
  }, products == null ? void 0 : products.map((_a, index) => {
    var _b = _a, { onWrapperAuxClick, onWrapperClick } = _b, restItem = ProductList_es_objRest(_b, ["onWrapperAuxClick", "onWrapperClick"]);
    return /* @__PURE__ */ react.createElement(ItemWrapper, {
      key: index,
      onAuxClick: onWrapperAuxClick,
      onClick: onWrapperClick
    }, /* @__PURE__ */ react.createElement(ProductListItem, ProductList_es_spreadProps(ProductList_es_spreadValues({}, restItem), {
      tracking: regionName ? (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName,
        contentName: restItem.sku,
        target: "productDetail",
        index: itemsPerPage ? index + (page - 1) * itemsPerPage : index,
        payload: restItem.bestComboDiscount && Number(restItem.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      ctaTracking: regionName && contactLink ? (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName,
        contentName: "contactSale",
        target: contactLink,
        payload: JSON.stringify({ sku: restItem.sku })
      }) : {},
      addToCart: hideCtaButton ? void 0 : restItem.addToCart
    })));
  })));
};
const ProductList_es_Wrapper = emotion_styled_browser_esm["default"].div`
  width: 100%;
`;
const ItemWrapperDesktop = emotion_styled_browser_esm["default"].div`
  &:not(:last-child) {
    border-bottom: 1px solid #e4e5f0;
  }
`;
const ItemWrapperMobile = emotion_styled_browser_esm["default"].div`
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/DeliveryDatetimePicker/DeliveryDatetimePicker.es.js
var DeliveryDatetimePicker_es = __webpack_require__(845404);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/HorizontalSlider/HorizontalSlider.es.js
var HorizontalSlider_es = __webpack_require__(784241);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NavBar/NavBar.es.js
var NavBar_es = __webpack_require__(598227);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPromotion/PromotionItem.es.js
var PromotionItem_es = __webpack_require__(645199);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/EmptyState/EmptyState.es.js + 1 modules
var EmptyState_es = __webpack_require__(154064);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Cart/SellerLine/SellerLine.es.js
var SellerLine_es = __webpack_require__(891438);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/GroupBuyShareButton/GroupBuyShareButton.es.js
var GroupBuyShareButton_es = __webpack_require__(151078);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/TekoLink/TekoLink.es.js
var TekoLink_es = __webpack_require__(675601);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/PriceFilter/PriceFilter.es.js
var PriceFilter_es = __webpack_require__(605078);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/HotDeal/index.es.js + 2 modules
var HotDeal_index_es = __webpack_require__(783047);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/PromotionOption/PromotionOption.es.js
var PromotionOption_es = __webpack_require__(341291);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BestSellingCategories/BestSellingCategories.es.js






var BestSellingCategories_es_defProp = Object.defineProperty;
var BestSellingCategories_es_defProps = Object.defineProperties;
var BestSellingCategories_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var BestSellingCategories_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var BestSellingCategories_es_hasOwnProp = Object.prototype.hasOwnProperty;
var BestSellingCategories_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var BestSellingCategories_es_defNormalProp = (obj, key, value) => key in obj ? BestSellingCategories_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var BestSellingCategories_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (BestSellingCategories_es_hasOwnProp.call(b, prop))
      BestSellingCategories_es_defNormalProp(a, prop, b[prop]);
  if (BestSellingCategories_es_getOwnPropSymbols)
    for (var prop of BestSellingCategories_es_getOwnPropSymbols(b)) {
      if (BestSellingCategories_es_propIsEnum.call(b, prop))
        BestSellingCategories_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var BestSellingCategories_es_spreadProps = (a, b) => BestSellingCategories_es_defProps(a, BestSellingCategories_es_getOwnPropDescs(b));
var BestSellingCategories_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (BestSellingCategories_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && BestSellingCategories_es_getOwnPropSymbols)
    for (var prop of BestSellingCategories_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && BestSellingCategories_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCategories = emotion_styled_browser_esm["default"].div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  height: 335px;
  overflow-x: scroll;
`;
const BestSellingCategories_es_Category = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  height: 144px;
  width: 144px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-right: 16px;
  margin-top: 1px;
  background: #fff;
  margin-bottom: 20px;
`;
const CategoryName = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Body */.uT)`
  z-index: 1;
  background-color: white;
  padding: 3px 10px;
  border-radius: 11px;
  position: relative;
  max-width: 90%;
  box-shadow: 0 4px 8px 0 #d9d9d9;
  position: absolute;
  bottom: -8px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 400;
  margin-left: 6px;
`;
const BestSellingCategories = (_a) => {
  var _b = _a, {
    categories,
    title
  } = _b, props = BestSellingCategories_es_objRest(_b, [
    "categories",
    "title"
  ]);
  if (!categories.length)
    return null;
  return /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, BestSellingCategories_es_spreadProps(BestSellingCategories_es_spreadValues({}, props), {
    backgroundColor: "white",
    paddingLeft: "s16"
  }), /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, {
    title
  }), /* @__PURE__ */ react.createElement(StyledCategories, null, categories.map((category, index) => /* @__PURE__ */ react.createElement(TekoLink_es/* TekoLink */.A, BestSellingCategories_es_spreadValues({
    key: index
  }, category.link), /* @__PURE__ */ react.createElement(BestSellingCategories_es_Category, BestSellingCategories_es_spreadValues({}, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "topCategories",
    contentName: category.id,
    target: "categoryLv2ListProduct",
    index
  })), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    contain: true,
    border: true,
    borderRadius: 8,
    src: category.image,
    alt: category.campaignName,
    imageWidth: 200
  }), /* @__PURE__ */ react.createElement(CategoryName, {
    fontSize: 12,
    maxLines: 1
  }, category.campaignName))))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductImageCarousel/ProductImageCarousel.es.js
var ProductImageCarousel_es = __webpack_require__(251165);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NextImage.es.js
var NextImage_es = __webpack_require__(401204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/RecentSearch/RecentSearch.es.js
var RecentSearch_es = __webpack_require__(652833);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SearchOutlined.es.js
var SearchOutlined_es = __webpack_require__(877936);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CheckOutlined.es.js
var CheckOutlined_es = __webpack_require__(4247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/ListContent/ListContent.es.js
var ListContent_es = __webpack_require__(25287);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
// EXTERNAL MODULE: ../../packages/utils/dist/string.es.js
var string_es = __webpack_require__(679376);
// EXTERNAL MODULE: ../../packages/utils/dist/tsx.es.js
var tsx_es = __webpack_require__(974108);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/LocationPicker/LocationPicker.es.js







const StyledListContent = (0,emotion_styled_browser_esm["default"])(ListContent_es/* ListContent */.y)`
  cursor: pointer;
  height: 3rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;
const LocationPicker = ({
  isShowed,
  setShowed,
  locations,
  selectedLocation,
  onSelectLocation,
  isMobile,
  hideSearchBox
}) => {
  const [keyword, setKeyword] = (0,react.useState)("");
  const listRef = (0,react.useRef)();
  const selectedLocationRef = (0,react.useRef)(null);
  const locationsForSearching = (0,react.useMemo)(() => {
    const keywordLocationMap = /* @__PURE__ */ new Map();
    locations.forEach((location) => {
      const normalizedLocationName = (0,string_es/* normalizeText */.b)(location.locationName, true);
      const _locations = keywordLocationMap.get(normalizedLocationName);
      if (_locations) {
        _locations.push(location);
      } else {
        keywordLocationMap.set(normalizedLocationName, [location]);
      }
    });
    return keywordLocationMap;
  }, [locations]);
  const showedLocations = (0,react.useMemo)(() => {
    const keywords = Array.from(locationsForSearching.keys());
    const normalizedKeyword = (0,string_es/* normalizeText */.b)(keyword, true);
    const result = [];
    keywords.forEach((keyword2) => {
      if (keyword2.includes(normalizedKeyword)) {
        const locations2 = locationsForSearching.get(keyword2);
        if (locations2) {
          result.push(...locations2);
        }
      }
    });
    return result;
  }, [keyword, locationsForSearching]);
  (0,react.useEffect)(() => {
    if (!isShowed) {
      setKeyword("");
    } else {
      setTimeout(() => {
        if (listRef.current && selectedLocationRef.current) {
          const listRect = listRef.current.getBoundingClientRect();
          const selectedLocationRect = selectedLocationRef.current.getBoundingClientRect();
          listRef.current.scrollBy({
            top: selectedLocationRect.y - listRect.y - listRect.height / 4,
            behavior: "smooth"
          });
        }
      }, 500);
    }
  }, [isShowed]);
  return /* @__PURE__ */ react.createElement(tsx_es/* ConditionalWrapper */.M, {
    wrapper: StyledModal,
    condition: !isMobile,
    visible: isShowed,
    onClose: () => {
      setShowed(false);
    },
    footer: false,
    showCloseIcon: false
  }, /* @__PURE__ */ react.createElement(tsx_es/* ConditionalWrapper */.M, {
    wrapper: StyledBottomSheet,
    condition: !!isMobile,
    show: isShowed,
    closeBottomSheet: () => {
      setShowed(false);
    }
  }, /* @__PURE__ */ react.createElement(Header, {
    justify: "center"
  }, /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, null, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    justify: "center"
  }, !isMobile ? /* @__PURE__ */ react.createElement(Typography_index_es/* Title */.Dx, {
    weight: "medium",
    level: 3
  }, (0,i18n_es.t)("Ch\u1ECDn khu v\u1EF1c nh\u1EADn h\xE0ng")) : /* @__PURE__ */ react.createElement(Typography_index_es/* SubTitle */.DK, {
    weight: "medium",
    level: 2
  }, (0,i18n_es.t)("Ch\u1ECDn khu v\u1EF1c nh\u1EADn h\xE0ng"))), /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    justify: "center"
  }, /* @__PURE__ */ react.createElement(Typography_index_es/* Caption */.YS, {
    level: 1,
    weight: "medium",
    color: "textSecondary"
  }, (0,i18n_es.t)("Vui lo\u0300ng cho\u0323n khu v\u01B0\u0323c nh\xE2\u0323n ha\u0300ng c\u1EE7a b\u1EA1n")))), /* @__PURE__ */ react.createElement(CloseIconContainer, {
    onClick: () => {
      setShowed(false);
    },
    isMobile
  }, /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    size: "1.5rem"
  }))), !hideSearchBox && /* @__PURE__ */ react.createElement(InputContainer, null, /* @__PURE__ */ react.createElement(StyledInput, {
    prefix: /* @__PURE__ */ react.createElement(SearchOutlined_es/* SearchOutlined */.l, null),
    placeholder: (0,i18n_es.t)("T\xECm ki\u1EBFm T\u1EC9nh/ Th\xE0nh ph\u1ED1"),
    value: keyword,
    onChange: setKeyword,
    isMobile
  })), /* @__PURE__ */ react.createElement(List, {
    ref: (ref) => {
      if (!ref) {
        return;
      }
      if (ref.scrollHeight > ref.clientHeight) {
        ref.style.paddingRight = "0";
      }
      listRef.current = ref;
    },
    isMobile
  }, showedLocations.length ? showedLocations.map((location, i, arr) => {
    const isSelected = location === selectedLocation;
    return /* @__PURE__ */ react.createElement(StyledListContent, {
      key: location.locationCode,
      label: location.locationName,
      hasDivider: i < arr.length - 1,
      onClick: () => {
        onSelectLocation(location);
      },
      extra: isSelected ? /* @__PURE__ */ react.createElement(CheckOutlined_es/* CheckOutlined */.b, {
        color: "primary500",
        size: "1.5rem"
      }) : void 0,
      ref: isSelected ? selectedLocationRef : void 0,
      "data-testid": isSelected ? "selectedItem" : void 0
    });
  }) : /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    justify: "center",
    align: "middle"
  }, /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    color: "placeholder",
    level: 1,
    weight: "regular"
  }, (0,i18n_es.t)("Kh\xF4ng t\xECm th\u1EA5y t\u1EC9nh th\xE0nh ph\u1ED1 n\xE0o !!"))))));
};
const StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)`
  .teko-modal-content {
    padding: 1rem 0;
    width: 32.5rem;
  }
`;
const Header = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)`
  position: relative;
  padding: 0.5rem 1rem;
`;
const CloseIconContainer = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)`
  position: absolute !important;
  ${({ isMobile }) => !isMobile ? "right" : "left"}: 1.375rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;
const InputContainer = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)`
  padding: 0.5rem 1rem;
`;
const StyledInput = (0,emotion_styled_browser_esm["default"])(Input_es/* Input */.I)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${({ isMobile }) => !isMobile ? "0 1rem" : "0"};
  border-radius: 4px;

  .input-container {
    border: none;
  }
`;
const List = emotion_styled_browser_esm["default"].div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: min(70vh, 28rem);
  padding: 0 0.75rem;
  padding-bottom: ${({ isMobile }) => isMobile ? "0.75rem" : "0"};

  ::-webkit-scrollbar {
    width: 0.75rem;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.disable};
    background-clip: content-box;
    border-radius: 100px;
    border: 0.25rem solid transparent;
    width: 0.25rem;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.placeholder};
  }
`;
const StyledBottomSheet = (0,emotion_styled_browser_esm["default"])(BottomSheet_es/* BottomSheet */.R)`
  width: 100%;
  z-index: 1060;

  & > div {
    max-height: 100vh;
    overflow: auto;
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/WarningChangePaymentMethod/WarningChangePaymentMethod.es.js
var WarningChangePaymentMethod_es = __webpack_require__(312408);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Facebook/FacebookComment.es.js
var FacebookComment_es = __webpack_require__(14766);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Facebook/useFacebook.es.js
var useFacebook_es = __webpack_require__(724656);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/CustomCategoryList/CustomCategoryList.es.js
var CustomCategoryList_es = __webpack_require__(834942);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Description/Description.es.js
var Description_es = __webpack_require__(124902);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/OrderShipments/OrderShipments.es.js
var OrderShipments_es = __webpack_require__(580280);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Shipment/Shipment.es.js
var Shipment_es = __webpack_require__(471206);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductVideo/ProductVideo.es.js
var ProductVideo_es = __webpack_require__(7297);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/CountdownTime/CountdownTime.es.js
var CountdownTime_es = __webpack_require__(883578);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/time.es.js
var time_es = __webpack_require__(487319);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/megaMenu.es.js
var megaMenu_es = __webpack_require__(369985);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/browser-share.es.js
var browser_share_es = __webpack_require__(72401);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/index.es.js



































































/***/ })

}]);